import { render, staticRenderFns } from "./Incident-List.vue?vue&type=template&id=08adc9a3&"
import script from "./Incident-List.vue?vue&type=script&lang=ts&"
export * from "./Incident-List.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports